import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RecoilRoot } from "recoil";
import App from "./App";
// import RecoilNexus from "recoil-nexus";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import CustomToast from "./components/modal/CustomToast";
import ConfirmRecoilModal from "./components/modal/ConfirmRecoilModal";
import ConsultModal from "./components/modal/ConsultModal";

// import SocketService from "./screens/socket/Socket";

if (
  process.env.REACT_APP_API_BEHIND_URL != undefined &&
  process.env.REACT_APP_API_BEHIND_URL === "PRD"
) {
  console.log = () => null;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <>
      <RecoilRoot>
        <BrowserRouter
          basename={
            process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : ""
          }
        >
          <App />
          <CustomToast message="" type="success" />
          <ConfirmRecoilModal />
          <ConsultModal />
        </BrowserRouter>
      </RecoilRoot>
    </>
  </React.StrictMode>
);

reportWebVitals();
